const mySongsData = {
    myCollection:[],
    myLikes:[]
}

export default mySongsData;